import { useQuery } from '@tanstack/react-query';
import type { Skill } from '@teentack/shared';
import { fetchSkills } from '@/lib/api-client';

/**
 * The skills catalogue. It changes rarely, so it is cached for the session and
 * never refetched while the signup wizard is open.
 */
export function useSkills() {
  return useQuery<Skill[]>({
    queryKey: ['skills'],
    queryFn: fetchSkills,
    staleTime: Infinity,
  });
}
